import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ToolsService } from '../tools/tools.service';

@Injectable({
  providedIn: 'root'
})
export class BaseService {

  urlBase: string = "https://www.connectill.com/api.php";


  constructor(
    private http: HttpClient,
    private tools: ToolsService
  ) { }

  postBase(action: string, location: string, otherParams?: string): Promise<any> {
    let that = this;
    let params = "action=" + action + "&type=" + location + "&LOGIN=" + that.tools.getStor("user_id");

    if (otherParams) { params += otherParams; }

    let newPromise = new Promise(function (resolve, reject) {
      that.http.post(that.urlBase, params, {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        }
      }).toPromise().then(data => {
        resolve(data);
      }).catch(err => {
        reject(err);
      })

    })
    return newPromise;
  }

 

}


